// Bootstrap's large (lg) breakpoint set at 992px for larger screens (like desktops/tablets).
const BREAKPOINT_LG = 992;
export default BREAKPOINT_LG;